// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"83785704","316":"796527af"}[chunkId] + ".chunk.js";
};